import { useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_Options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

export const usePropertyTableTenants = (
  listingAlias: ListingAlias,
  options: Partial<RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants_Options> = {},
) => {
  const { data, error, isFetching } = useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants(
    { listingAlias },
    {
      ...options,
      enabled: Boolean(listingAlias) && (options.enabled ?? true),
      meta: {
        tags: ['propertyTableTenants', listingAlias],
        context: {
          api: 'useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_tenants',
          details: 'usePropertyTableTenants',
        },
      },
    },
  );

  return {
    data,
    isFetching,
    error,
  };
};
